<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text alt">
                        <p class="main">Independent Banker</p>
                    </div>
                </div>
            </div>


            <!--        Intro Text-->
            <div class="all-account-component">
                <div class="all-accounts">

                    <div class="all-account-top i-banker-mob">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="hold">
                                    <div class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-6 0 591 591.2">
                                            <path d="M11 163.3C10.8 164.4 10.6 165.6 10.6 166.8L10.6 191.1C10.6 201.1 16.8 210.1 26.2 213.6L26.2 249.4C26.3 261.3 35.7 271.2 47.7 271.8L47.7 478.4C35.7 479 26.3 488.8 26.2 500.8L26.2 536.5C16.8 540.1 10.6 549.1 10.6 559.2L10.6 583C10.6 587.4 14.2 591 18.6 591L560.4 591C564.8 591 568.4 587.4 568.4 583L568.4 559.2C568.4 549.1 562.2 540.1 552.8 536.5L552.8 500.6C552.7 488.6 543.3 478.8 531.4 478.2L531.4 271.8C543.3 271.2 552.7 261.3 552.8 249.4L552.8 213.6C562.2 210.1 568.4 201.1 568.4 191.1L568.4 166.9C568.4 165.8 568.3 164.6 568 163.4 572.1 165.2 576.8 163.4 578.6 159.3 580.4 155.3 578.6 150.6 574.5 148.8L293.2 0.9C290.9-0.3 288.1-0.3 285.7 0.9L4.4 148.6C0.5 150.7-1.1 155.6 1 159.5 2.9 163.1 7.2 164.7 11 163.3ZM42.3 227.5L42.3 215.1 134.9 215.1 134.9 227.4ZM248.6 271.8L248.6 478.4C236.6 479 227.2 488.8 227.2 500.8L227.2 535 150.9 535 150.9 500.8C150.9 488.8 141.4 479 129.5 478.4L129.5 271.8C141.4 271.2 150.9 261.3 150.9 249.4L150.9 215.1 227.1 215.1 227.1 249.3C227.1 261.3 236.5 271.2 248.5 271.8ZM243.2 227.5L243.2 215.1 335.9 215.1 335.9 227.4ZM449.5 271.8L449.5 478.4C437.6 479 428.1 488.8 428.1 500.8L428.1 535 351.8 535 351.8 500.8C351.8 488.8 342.4 479 330.4 478.4L330.4 271.8C342.4 271.2 351.8 261.3 351.8 249.4L351.8 215.1 428 215.1 428 249.3C428 261.3 437.4 271.2 449.4 271.8ZM444.2 227.5L444.2 215.1 536.8 215.1 536.8 227.4ZM536.8 522.7L536.8 535 444.1 535 444.1 522.7ZM335.9 522.7L335.9 535 243.1 535 243.1 522.7ZM256.5 255.9L249.6 255.9C246 255.9 243.1 253 243.1 249.4L243.1 243.6 335.8 243.6 335.8 249.4C335.8 253 332.9 255.9 329.4 255.9ZM314.4 271.9L314.4 478.3 264.6 478.3 264.6 271.9C264.6 271.9 314.4 271.9 314.4 271.9ZM256.5 494.4L329.4 494.4C332.9 494.4 335.8 497.3 335.8 500.8L335.8 506.7 243.1 506.7 243.1 500.8C243.1 497.3 246 494.4 249.6 494.4ZM134.8 522.7L134.8 535 42.2 535 42.2 522.7ZM42.2 249.6L42.2 243.6 134.8 243.6 134.8 249.4C134.8 253 132 255.9 128.4 255.9L48.5 255.9C44.9 255.8 42.2 252.9 42.2 249.4ZM113.4 272.1L113.4 478.3 63.6 478.3 63.6 271.9ZM42.2 501C42.2 497.4 45.1 494.5 48.6 494.5L128.4 494.5C132 494.5 134.8 497.4 134.8 501L134.8 506.8 42.2 506.8ZM552.4 559.5L552.4 575.3 26.6 575.3 26.6 559.5C26.6 554.9 30.3 551.2 34.9 551.2L544.1 551.2C548.6 551.2 552.3 554.8 552.4 559.3 552.4 559.3 552.4 559.5 552.4 559.5ZM536.7 501L536.7 506.8 444.1 506.8 444.1 501C444.1 497.4 446.9 494.5 450.5 494.5L530.5 494.5C533.9 494.6 536.6 497.4 536.7 500.8ZM465.5 478.5L465.5 271.9 515.3 271.9 515.3 478.3ZM536.7 249.6C536.7 253.1 533.8 256 530.3 256L450.5 256C447 256 444.1 253.1 444.1 249.6L444.1 243.6 536.8 243.6ZM289.5 17L528.7 142.7 50.2 142.7ZM26.6 166.9C26.6 162.5 30.1 158.9 34.6 158.9L544.3 158.9C548.8 158.9 552.4 162.5 552.4 166.9L552.4 191.3C552.4 195.7 548.8 199.3 544.3 199.3L34.6 199.3C30.1 199.3 26.6 195.7 26.6 191.3ZM26.6 166.9"></path>
                                        </svg>
                                    </div>
                                    <div class="info">
                                        <p v-if="isNaN(IbankerBalance) || IbankerBalance === ''" class="name"><span class="currency">₦</span>0.00</p>
                                        <p v-else class="name"><span class="currency">₦</span>{{IbankerBalance | newAmountFormatter}}</p>
                                        <p class="count">{{registeredList.length}}/{{unregisteredList.length + registeredList.length}} Customers</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div class="balance">
                                    <div class="float-right">
                                        <ui-switch
                                                v-model="ibankerSwitch" color="accent"
                                                checked @change="reviewSwitchState()"
                                        >
                                            <p v-if="ibankerSwitch" class="pageSubHeader">Not Registered</p>
                                            <p v-else class="pageSubHeader">Registered Bankers</p>
                                        </ui-switch>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--<div class="row">-->
                    <div class="invite-link">
                        <span class="link-lable">Invite Link</span>
                        <div class="input-group mb-3">
                            <input type="text" id="ibanker-link" class="form-control form-input" :value="'https://rubiesbank.page.link/?link=https://www.rubies.ng/ibanker/'+getDataOnLogin.referralcode+'&apn=com.qucoon.rubies&isi=1458430556&ibi=com.highstreetmfb.rubies'" readonly="">
                            <div @click="copyToClipboard()" class="input-group-append">
                                <span class="input-group-text">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488.3 488.3">
                                        <path d="M314.3 85.4h-227c-21.3 0-38.6 17.3-38.6 38.6v325.7c0 21.3 17.3 38.6 38.6 38.6h227c21.3 0 38.6-17.3 38.6-38.6V124C352.8 102.7 335.5 85.4 314.3 85.4zM325.8 449.6c0 6.4-5.2 11.6-11.6 11.6h-227c-6.4 0-11.6-5.2-11.6-11.6V124c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6V449.6z"></path>
                                        <path d="M401.1 0h-227c-21.3 0-38.6 17.3-38.6 38.6 0 7.5 6 13.5 13.5 13.5s13.5-6 13.5-13.5c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6v325.7c0 6.4-5.2 11.6-11.6 11.6 -7.5 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5c21.3 0 38.6-17.3 38.6-38.6V38.6C439.7 17.3 422.4 0 401.1 0z"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                    <!--</div>-->


                    <div class="ibanker-table mt-2">
                        <div class="">
                            <!--<div class="header">-->
                            <!--<div class="row">-->
                            <!--<div class="col-sm-12">-->
                            <!--<p class="mb-0">Customers</p>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</div>-->

                            <div class="history-table">
                                <div class="tbl i-banker-mob">
                                    <div v-if="currentIBankerList.toString() === ''">
                                        <div class="empty-history">
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                                    <circle cx="25" cy="25" r="25"></circle>
                                                    <line x1="25" y1="10" x2="25" y2="32" class="a"></line>
                                                    <line x1="25" y1="37" x2="25" y2="39" class="a"></line>
                                                </svg>
                                            </span>
                                            <p>
                                                {{fetchError}}
                                            </p>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-for="banker in currentIBankerList" class="account-statement-group">
                                            <div>
                                                <div class="account-statement">
                                                    <article class="amount">
                                                        <div v-if="banker.status ==='NR'" class="dbt"></div>
                                                        <div v-else-if="banker.status ==='RA'" class="crd"></div>
                                                        <div v-else class="myb"></div>
                                                        {{banker.customername}}
                                                    </article>
                                                    <article class="type">
                                                        <div v-if="banker.email">{{banker.email}}</div>
                                                        <div v-else>--</div>
                                                    </article>
                                                    <article class="counterparty">
                                                        +{{banker.countrycode}}{{banker.mobilenumber}}
                                                    </article>
                                                    <article class="icon">
                                                        <!--<a><span class="fa fa-eye"></span></a>-->
                                                        <a @click="moreIBankerInfo(banker)">
                                                        <span>
                                                            <i class="nav-icon i-Information"></i>
                                                        </span>
                                                        </a>
                                                    </article>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <!--UI Modal For Displaying Full Transaction Details-->
                <ui-modal
                        ref="fullIBankerModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="fullIBankerModalHide"
                        align-top :align-top-margin="50"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body history">
                                <div class="">
                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <div class="logo alt">
                                                    <img
                                                            :src="currentIBanker.profileimage"
                                                            alt="Banker Image"
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <div class="amount">
                                                    <div class="crdDbt">
                                                        <span v-if="currentIBanker.status === 'NR'" class="dbt"></span>
                                                        <span v-else-if="currentIBanker.status === 'RA'" class="crd"></span>
                                                        <span v-else class="myb"></span>
                                                    </div>

                                                    <p class="bankerName">
                                                        {{currentIBanker.customername}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="currentIBanker.email">
                                        <div class="trnxHist">
                                            <div class="row">
                                                <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                    <p class="histLabel">Email</p>
                                                </div>
                                                <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                    <p class="histRecord">
                                                        {{currentIBanker.email}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                                                <p class="histLabel">Mobile</p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-8 col-8 text-right">
                                                <p class="histRecord">+{{currentIBanker.countrycode}}{{currentIBanker.mobilenumber}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button alt pb-2">
                                <button @click="sendMoneyToIBanker(currentIBanker.countrycode, currentIBanker.mobilenumber)" class="btn btn-primary btn-xnax-login alt">Send Money</button>
                                <button @click="sendAirtimeToIBanker(currentIBanker.countrycode, currentIBanker.mobilenumber)" class="btn btn-primary btn-xnax-login alt">Send Airtime</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>
            </div>

            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";


    export default {
        name: "IndependentBanker",
        components: {
            FooterMobile,
            mobileLeftBar: MobileLeftBar,
        },
        props: { },
        data () {
            return {
                currentIBanker: [],

                orderedAccountList: [],
                totalAvailableBalance: 0,

                unregisteredList: [],
                registeredList: [],

                ibankerSwitch: false,
                currentIBankerList: [],

                IbankerBalance: '',

                fetchError: 'No Record Found!',
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
                'getIBankerList',
            ])
        },
        created () {
            this.orderedAccountList = this.getDataOnLogin.accountlist.sort(this.compare);

            this.totalAvailableBalance = this.orderedAccountList.map((elem)=>{
                return parseFloat(elem.availablebalance)
            });

            this.currentIBankerList = this.getIBankerList.filter(banker => banker.status === 'NR');

            this.splitIbankerList();

            this.ibankerBaalance();
        },
        methods: {
            ...mapActions([
                'updateAppLoading',
                'updateSideBarPage',
                'updateInsideCurrentPage',
                'updateCurrentAccountForAction',
                'updateCurrentAirtimePhoneNo',
                'updateCurrentTransferPhoneNo',
            ]),

            backButton(){
                this.updateInsideCurrentPage('dashboard');
                this.updateSideBarPage('dashboard');
            },
            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },
            copyToClipboard(){
                // let ibankerLink = document.querySelector('#ibanker-link').value
                //
                // // console.log('IBANKER LINK ==>>', ibankerLink)

                let testingCodeToCopy = document.querySelector('#ibanker-link')
                testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
                testingCodeToCopy.select()

                try {
                    let successful = document.execCommand('copy');
                    let msg = successful ? 'successful' : 'unsuccessful';
                    // alert('Invite Link copied ' + msg);
                } catch (err) {
                    // console.log('Coping Error', err)
                    // alert('Oops, unable to copy');
                }

                /* unselect the range */
                // testingCodeToCopy.setAttribute('type', 'hidden')
                // window.getSelection().removeAllRanges()


            },

            splitIbankerList(){
                let totalList = this.getIBankerList

                this.unregisteredList = totalList.filter(banker => banker.status === 'NR');

                this.registeredList = totalList.filter(banker => banker.status !== 'NR');
            },
            reviewSwitchState(){
                let totalList = this.getIBankerList;

                if (this.ibankerSwitch === true){
                    // equate the currentMoneyRequest to the sent requests in the store
                    this.currentIBankerList = totalList.filter(banker => banker.status === 'NR')
                }
                else {
                    // equate the currentMoneyRequest to the Received requests in the store
                    this.currentIBankerList = totalList.filter(banker => banker.status !== 'NR')
                }

                // console.log('Rest..')
            },
            ibankerBaalance(){
                let ibankerAccount = this.getDataOnLogin.accountlist.filter(account => account.account_type === 'IBANKER')

                if (ibankerAccount[0].availablebalance){
                    // console.log('available balance ==>', ibankerAccount[0].availablebalance);

                    this.IbankerBalance =  ibankerAccount[0].availablebalance;
                }
                else {
                    // console.log('available balance 2 ==>', ibankerAccount[0].availablebalance);

                    this.IbankerBalance =  '';
                }

            },

            sendMoneyToIBanker(_countryCode, _phoneNumber){

                // update current transfer phone number
                this.updateCurrentTransferPhoneNo([_countryCode, _phoneNumber]);

                //Update the current sub component in the store
                this.updateInsideCurrentPage('phoneTransfer')
            },

            sendAirtimeToIBanker(_countryCode, _phoneNumber){

                // update current airtime phone number
                this.updateCurrentAirtimePhoneNo([_countryCode, '0'+_phoneNumber]);

                //Update the current sub component in the store
                this.updateInsideCurrentPage('airtime')
            },


            //compare
            compare(a,b) {
                if (a.availablebalance > b.availablebalance)
                    return 1;
                if (a.availablebalance < b.availablebalance)
                    return -1;
                return 0;
            },
            getSum(total, num) {
                return total + num;
            },
            moreIBankerInfo(_banker){
                // console.log('Selected Banker ==>', _banker);

                this.currentIBanker = _banker;

                //Show Success Modal and then redirect to the home page / login page
                this.openModal('fullIBankerModal');
            },
            fullIBankerModalHide(){},


            refetchIbankers(){
                //start app loading
                this.updateAppLoading(true);


                let bodyToSend = {
                    customerid: this.getDataOnLogin.customerid,
                }

                axios
                    .post('/mybankercustomers', bodyToSend,
                        {
                            headers : {
                                'Authorization': this.getDataOnLogin.authorization,
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*'
                            }})
                    .then(response => {
                        //stop app running
                        this.updateAppLoading(false);

                        let responseData =  response.data;

                        // console.log('responseData ==>>', responseData)

                        if (responseData.responsecode === '00' || responseData.responsecode === '01') {
                            if (responseData.responsecode === '01'){
                                this.updateIBankerList([])
                            } else {
                                this.updateIBankerList(responseData.result)
                            }

                            //update "sideBarPage" in the store
                            this.updateSideBarPage('independent-banker');

                            //Update the current sub component in the store
                            // this.updateInsideCurrentPage('independentBanker')

                        } else {

                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                    })
                    .catch(error => {
                        //stop app running
                        this.updateAppLoading(false);

                        // log Error
                        // console.log(error);
                    })
            }


        },
        mounted(){
            this.$nextTick(()=>{});
        },
    }
</script>

<style scoped>
.all-account-top {
    /*padding: 20px 10px;*/
    margin-bottom: 0;
}
.pageSubHeader{
    margin: 0;
    /*color: #c02026;*/
    font-size: 12px;
}
</style>